import styled from 'styled-components';

import colors from 'utils/colors';

import { Label as AutocompleteLabel } from '../../AutoComplete/styled';

export const BaseWrapper = styled.div``;

export const Wrapper = styled(BaseWrapper)`
  display: flex;
  flex-direction: column;
`;

export const HeadingWrapper = styled(BaseWrapper)`
  margin-bottom: 17px;
`;

export const DetailsWrapper = styled(Wrapper)``;

export const ManualAddressLinkWrapper = styled(BaseWrapper)`
  margin-top: 8px;
`;

export const BackToManualAddressLinkWrapper = styled(BaseWrapper)`
  margin-bottom: 24px;
`;

export const ToggleAddressMode = styled.a`
  text-decoration: underline;
  font-size: 16px;
  font-weight: 500;
  color: ${colors.orange};
`;

export const GoBackToAutoWrapper = styled.a``;

export const InputContainer = styled(BaseWrapper)`
  margin: 8px 0;
`;

export const Label = styled(AutocompleteLabel)`
  display: block;
  margin-bottom: 8px;
`;
